var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6768 15.8339C17.795 13.9509 17.8571 11.9995 17.8571 9.9999C17.8571 9.19007 17.847 8.38814 17.827 7.59544C17.813 7.03857 17.6323 6.49738 17.3027 6.04832C16.0463 4.33672 15.0454 3.27264 13.3958 1.99957C12.9425 1.64971 12.3863 1.4599 11.8138 1.44738C11.2398 1.43484 10.6403 1.42847 9.99997 1.42847C8.06147 1.42847 6.49775 1.48685 4.87954 1.59811C3.50291 1.69277 2.40958 2.78867 2.32314 4.16584C2.20495 6.04894 2.14282 8.00034 2.14282 9.9999C2.14282 11.9995 2.20495 13.9509 2.32314 15.8339C2.40958 17.2112 3.50291 18.307 4.87954 18.4016C6.49775 18.5129 8.06147 18.5713 9.99997 18.5713C11.9385 18.5713 13.5022 18.5129 15.1204 18.4016C16.497 18.307 17.5904 17.2112 17.6768 15.8339Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27673 10.0222H12.7232",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27673 14.1741H12.7062M7.27673 5.71436H10.5634",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTos);
export default __webpack_public_path__ + "static/media/tos.eb7e58bccae9d4d586be6266df367e08.svg";
export { ForwardRef as ReactComponent };